import i18next from 'i18next';
import * as React from 'react';
import { StandardLocalWidget, any, fromJSX, nothing } from "widgets-for-react";
import { FormControls } from "../../utils/forms";
import { singleValidatorResultBuilders } from "../../validator/validator";
import { companyWidget } from "../../forms/company/companyWidget";
import { paymentMethodWidget } from "../../forms/paymentMethod/paymentMethodWidget";
import { capitalize } from '../../utils/utils';
import { TextPageHeader } from '../../site/root/pageHeader/pageHeaderLayout';
import { RootLayout } from '../../site/root/rootLayout';
import { SubscriptionLayout } from "../subscriptionLayout";
import { SubscriptionState, subscriptionUpdaters } from "../subscriptionState";
import { payOpenInvoiceInputUpdaters } from "./payOpenInvoiceState";

export const payOpenInvoiceWidget: StandardLocalWidget<SubscriptionState> = currentState =>
  any([
    currentState.payOpenPayment.kind == "loaded" ?
      fromJSX(() =>
        currentState.payOpenPayment.kind == "loaded" ?
          currentState.payOpenPayment.value.Kind == "Redirect" ?
            <SubscriptionLayout.RedirectToPsp
              variant="other"
              redirectUrl={currentState.payOpenPayment.value.RedirectUrl}
            />
            : currentState.payOpenPayment.value.Kind == "Success" ?
              <SubscriptionLayout.ThankYou
                variant="pay-open-invoice-success"
                subscriptionState={currentState}
              />
              : <SubscriptionLayout.FailureOrCancel
                variant="pay-open-invoice-failure"
              />
          : <></>
      )
      : currentState.kind != "pay open payment flow" ? nothing() :
        fromJSX(setState => {
          const paymentFrequency = currentState.userSubscriptions.kind == "loaded" && 
          currentState.userSubscriptions.value.ActiveSubscription.length > 0 ?
            i18next.t(`subscription:${currentState.userSubscriptions.value.ActiveSubscription[0].Subscription.CurrencyPaymentFrequency == "Monthly" ? "monthly" : "yearly"}`)
            : ""
          return (
            <div className="text-screen">
              <TextPageHeader
                title={`${paymentFrequency ? capitalize(paymentFrequency) : ''} ${i18next.t('subscription:ProSubscription')}`}
                breadcrumbs={undefined}
              />

              <section className="block block--text has-dividers">
                <div className="block__inner container--m gutter--m">
                  <div className="block__content divide-children">
                    <div className="block__text">
                      <FormControls.FormRadioInGroup
                        name="subscriptionInvoiceAddress"
                        legend={i18next.t("subscription:InvoiceToCompany")}
                        required={true}
                        validation={singleValidatorResultBuilders.validating("")}
                        items={[
                          {
                            controlId: "subscriptionInvoiceAddressDifferent",
                            label: i18next.t("subscription:InvoiceWithCompany"),
                            checked: currentState.payOpenInvoiceInput.invoiceToCompany || false,
                            onChange: newValue => setState(subscriptionUpdaters.payOpenInvoiceInput(payOpenInvoiceInputUpdaters.invoiceToCompany(_ => newValue))),
                          },
                          {
                            controlId: "subscriptionInvoiceAddressSame",
                            label: i18next.t("subscription:InvoiceWithoutCompany"),
                            checked: !currentState.payOpenInvoiceInput.invoiceToCompany || false,
                            onChange: newValue => setState(subscriptionUpdaters.payOpenInvoiceInput(payOpenInvoiceInputUpdaters.invoiceToCompany(_ => !newValue))),
                          }
                        ]}
                      />
                      {currentState.payOpenInvoiceInput.invoiceToCompany ?
                        currentState.lookupData.kind == "loaded" && currentState.userSubscriptions.kind === "loaded" ?
                          companyWidget(currentState.lookupData.value.Countries, currentState.lookupData.value.CompanyTypes, false, currentState.userSubscriptions.value.User.Country !== null, true)(currentState.payOpenInvoiceInput.companyState)
                            .map(payOpenInvoiceInputUpdaters.companyState)
                            .map(subscriptionUpdaters.payOpenInvoiceInput)
                            .run(setState)
                          : <RootLayout.Loader hasWrapper showText />
                        : <></>}
                    </div>

                    <div className="block__text">
                      {currentState.lookupData.kind == "loaded" ?
                        paymentMethodWidget(currentState.lookupData.value.IDealIssuers)(currentState.payOpenInvoiceInput.paymentMethodState)
                          .map(payOpenInvoiceInputUpdaters.paymentMethodState)
                          .map(subscriptionUpdaters.payOpenInvoiceInput)
                          .run(setState)
                        : <RootLayout.Loader hasWrapper showText />}
                    </div>
                  </div>

                  <SubscriptionLayout.ActionAndBackButtons
                    back={() => setState(subscriptionUpdaters.overview)}
                    action={() => setState(subscriptionUpdaters.invokePayOpenPaymentApi)}
                    actionText={i18next.t("subscription:PayNow")}
                    actionDisabled={false}
                  />
                </div>
              </section>

            </div>
          )
        })
  ])
